import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PreauthorizedOffer } from 'src/app/models/state/preauthorized-offer.model';

export const selectPreauthorizedOfferState =
	createFeatureSelector<PreauthorizedOffer>('preauthorizedOffer');

export const selectOfferDataState = createSelector(
	selectPreauthorizedOfferState,
	(state: PreauthorizedOffer) => state
);

export const selectSelectedAmount = createSelector(
	selectPreauthorizedOfferState,
	state => state?.selectedAmount ?? 0
);

export const selectSelectedTerm = createSelector(
	selectPreauthorizedOfferState,
	state => state?.selectedTerm ?? 0
);

export const selectPreauthorizedMount = createSelector(
	selectPreauthorizedOfferState,
	state => state?.preauthorizedMount ?? 0
);

export const selectRate = createSelector(
	selectPreauthorizedOfferState,
	state => state?.rate ?? 0
);

export const selectApplicantPhone = createSelector(
	selectPreauthorizedOfferState,
	state => state?.applicantPhone ?? ''
);
